import {
  Credentials,
  GenerateSudoCredentialsRequest,
  GenerateSudoCredentialsResponse,
  GenerateUserAccessTokenRequest,
  GenerateUserAccessTokenResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type GenerateSudoCredentialsParams = {
  userId: string;
  requestedBy: string;
  reason: string;
};

export const generateSudoCredentials = async (
  { userId, requestedBy, reason }: GenerateSudoCredentialsParams,
  headers: Record<RequestMetadata, string>
): Promise<Credentials | undefined> => {
  const req = new GenerateSudoCredentialsRequest({
    userId,
    requestedBy,
    reason,
  });

  return supportServiceConnectClient
    .generateSudoCredentials(req, { headers })
    .then((res: GenerateSudoCredentialsResponse) => {
      return res.credentials;
    });
};

export const generateUserAccessToken = async (
  { userId, requestedBy, reason }: GenerateSudoCredentialsParams,
  headers: Record<RequestMetadata, string>
): Promise<string | undefined> => {
  const req = new GenerateUserAccessTokenRequest({
    userId,
    requestedBy,
    reason,
  });

  return supportServiceConnectClient
    .generateUserAccessToken(req, { headers })
    .then((res: GenerateUserAccessTokenResponse) => {
      return res.userToken;
    });
};
